export default __webpack_public_path__ + "static/media/marauders-map-v5.1-03-01.dd20afca.jpg";